var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    stroke: "currentColor",
    width: 253,
    height: 282,
    viewBox: "0 0 253 282",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    d: "M98.5853 22.4389C106.571 -5.54438 146.229 -5.54438 154.215 22.4389L159.322 40.3352C163.965 56.6025 180.678 66.2515 197.087 62.1384L215.139 57.6133C243.366 50.5378 263.195 84.8824 242.954 105.79L230.009 119.161C218.242 131.316 218.242 150.614 230.009 162.768L242.954 176.139C263.195 197.047 243.366 231.391 215.139 224.316L197.087 219.791C180.678 215.678 163.965 225.327 159.322 241.594L154.215 259.49C146.229 287.474 106.571 287.474 98.5853 259.49L93.4779 241.594C88.8354 225.327 72.1228 215.678 55.7137 219.791L37.6614 224.316C9.4341 231.391 -10.3948 197.047 9.84643 176.139L22.7914 162.768C34.558 150.614 34.558 131.316 22.7914 119.161L9.84643 105.79C-10.3948 84.8824 9.4341 50.5378 37.6614 57.6133L55.7137 62.1384C72.1228 66.2515 88.8354 56.6025 93.4779 40.3352L98.5853 22.4389Z",
    strokeWidth: 2.42072
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.7af73062dbde228ee951d1a9c5957040.svg";
export { ForwardRef as ReactComponent };